<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label-width
                          prop="create_time"
                          label="统计日期">
              <!-- <el-input v-model="form.create_time"></el-input> -->
              <el-date-picker type="monthrange"
                              style="width:100%"
                              v-model="form.create_time"
                              value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="item_id"
                          label="商品ID">
              <el-input v-model="form.item_id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="item_name"
                          label="商品名称">
              <el-input v-model="form.item_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="month"
                          label="月份">
              <number-range v-model="form.month"></number-range>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="Desc.actionLine">
        <!-- <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开" }}</el-button> -->
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              border
              :data="tableData"
              style="width: 100%">
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="统计日期"
                       width="100px"></el-table-column>
      <el-table-column prop="month"
                       align="center"
                       header-align="center"
                       label="月份"
                       width="60px"></el-table-column>
      <el-table-column prop="item_id"
                       align="center"
                       header-align="center"
                       label="商品ID"
                       width="110px"></el-table-column>
      <el-table-column prop="item_name"
                       align="center"
                       header-align="center"
                       label="商品名称"
                       width="160px"
                       show-overflow-tooltip></el-table-column>

      <el-table-column prop="item_id"
                       align="center"
                       header-align="center"
                       label="商品ID"
                       width="110px"></el-table-column>

      <el-table-column prop="item_name"
                       align="center"
                       header-align="center"
                       label="商品名称"
                       width="160px"
                       show-overflow-tooltip></el-table-column>

      <el-table-column prop="item_code"
                       align="center"
                       header-align="center"
                       label="货号"></el-table-column>
      <el-table-column prop="item_status"
                       align="center"
                       header-align="center"
                       label="商品状态"></el-table-column>

      <el-table-column prop="spfks"
                       align="center"
                       header-align="center"
                       label="商品访客数"
                       width="110px"></el-table-column>

      <el-table-column prop="splll"
                       align="center"
                       header-align="center"
                       label="商品浏览量"
                       width="160px"
                       show-overflow-tooltip></el-table-column>

      <el-table-column prop="pjtlsc"
                       align="center"
                       header-align="center"
                       label="平均停留时长"></el-table-column>
      <el-table-column prop="xqytclv"
                       align="center"
                       header-align="center"
                       label="详情页跳出率"></el-table-column>

      <el-table-column prop="spscrs"
                       align="center"
                       header-align="center"
                       label="商品收藏人数"
                       width="110px"></el-table-column>

      <el-table-column prop="spjgjs"
                       align="center"
                       header-align="center"
                       label="商品加购件数"
                       width="160px"
                       show-overflow-tooltip></el-table-column>

      <el-table-column prop="spjgrs"
                       align="center"
                       header-align="center"
                       label="商品加购人数"></el-table-column>
      <el-table-column prop="xdmjs"
                       align="center"
                       header-align="center"
                       label="下单买家数"></el-table-column>

      <el-table-column prop="xdjs"
                       align="center"
                       header-align="center"
                       label="下单件数"
                       width="110px"></el-table-column>

      <el-table-column prop="xdje"
                       align="center"
                       header-align="center"
                       label="下单金额"
                       width="160px"
                       show-overflow-tooltip></el-table-column>

      <el-table-column prop="xdzhlv"
                       align="center"
                       header-align="center"
                       label="下单转化率"></el-table-column>
      <el-table-column prop="zfmjs"
                       align="center"
                       header-align="center"
                       label="支付买家数"></el-table-column>

      <el-table-column prop="zfjs"
                       align="center"
                       header-align="center"
                       label="支付件数"
                       width="110px"></el-table-column>

      <el-table-column prop="zfje"
                       align="center"
                       header-align="center"
                       label="支付金额"
                       width="160px"
                       show-overflow-tooltip></el-table-column>

      <el-table-column prop="zfzhlv"
                       align="center"
                       header-align="center"
                       label="支付转化率"></el-table-column>
      <el-table-column prop="zfxmjs"
                       align="center"
                       header-align="center"
                       label="支付新买家数"></el-table-column>

      <el-table-column prop="zflmjs"
                       align="center"
                       header-align="center"
                       label="支付老买家数"
                       width="110px"></el-table-column>

      <el-table-column prop="lmjzfje"
                       align="center"
                       header-align="center"
                       label="老买家支付金额"
                       width="160px"
                       show-overflow-tooltip></el-table-column>

      <el-table-column prop="jhszfje"
                       align="center"
                       header-align="center"
                       label="聚划算支付金额"></el-table-column>
      <el-table-column prop="fkpjjz"
                       align="center"
                       header-align="center"
                       label="访客平均价值"></el-table-column>

      <el-table-column prop="cgtkthje"
                       align="center"
                       header-align="center"
                       label="售中售后成功退款金额"
                       width="110px"></el-table-column>

      <el-table-column prop="ssydzfzhlv"
                       align="center"
                       header-align="center"
                       label="搜索引导支付转化率"
                       width="160px"
                       show-overflow-tooltip></el-table-column>

      <el-table-column prop="ssydfks"
                       align="center"
                       header-align="center"
                       label="搜索引导访客数"></el-table-column>
      <el-table-column prop="ssydzfmjs"
                       align="center"
                       header-align="center"
                       label="搜索引导支付买家数"></el-table-column>

      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="130px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/canmou/itemtotalmonth/index.vue